import React from 'react';

// ── Flaga kraju jako SVG (flag-icons) ────────────────────────────────────────
// Renderuje sie IDENTYCZNIE na kazdym systemie. Emoji flag (regional indicator
// symbols) NIE dzialaja na Windows (brak glifow w foncie systemowym) --
// pokazywaly sie tylko na Androidzie/iOS/macOS. SVG rozwiazuje to raz na zawsze.
// Kod kraju ISO 3166-1 alpha-2 (np. "PL") -> klasa "fi fi-pl". Nieznany/pusty
// kod -> nic.
//
// Wydzielone do osobnego modulu, bo uzywaja go i App.js (POTA) i Wwff.js --
// wspolny import z osobnego pliku unika cyklu App <-> Wwff.
export default function Flag({ code, title }) {
  if (!code) return null;
  const cc = code.toLowerCase();
  return <span className={`fi fi-${cc}`} title={title || code}
    style={{ borderRadius: 2, marginRight: 6, verticalAlign: 'baseline' }} />;
}
